import interceptor from "../common/interceptor";
import { APIPaths } from "../common/constants";


//Call for fetching designations
export const  GetDesignations = (token) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosGet("Get", APIPaths.designations, token, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })
    });
};


//Call for product type dd
export const GetProductTypes =  (token) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosGet("Get", APIPaths.product_type, token, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })
    });
};


//Call for ccompany couriers
export const GetCompanyCouriers =  (token) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosGet("Get", APIPaths.settingsCourier, token, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })
    });
};



//Call for fetching designations
export const  GetTeamsDDL = (token,featureName) => {
    let url = `${APIPaths.teamsDDLForFeature}?feature=${featureName}`
    return new Promise((resolve, reject) => {
        interceptor.axiosGet("Get", url, token, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })
    });
};

